import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler,
  Title, Tooltip, Legend, } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement, Filler,
  Title, Tooltip, Legend
);

const MultiAreaChart = ({ chartData }) => {
  const sorted = [...chartData.data].sort((a, b) => new Date(a.month) - new Date(b.month));
  const labels = sorted.map((d) =>
    new Date(d.INVOICE_DATE).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    })
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Benchmark Cost",
        data: sorted.map((d) => d.BENCHMARK_COST),
        fill: true,
        borderColor: "#3FB8FF",
        backgroundColor: "rgba(63, 184, 255, 0.25)",
        tension: 0.3,
        pointRadius: 3,
      },
      {
        label: "New Cost",
        data: sorted.map((d) => d.NEW_COST),
        fill: true,
        borderColor: "#FF9F40",
        backgroundColor: "rgba(255, 159, 64, 0.25)",
        tension: 0.3,
        pointRadius: 3,
      },
      {
        label: "Savings",
        data: sorted.map((d) => d.SAVINGS),
        fill: true,
        borderColor: "#6EFFB8",
        backgroundColor: "rgba(110, 255, 184, 0.25)",
        tension: 0.3,
        pointRadius: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    stacked: false,
    plugins: {
      legend: {
        position: "top",
        labels: { color: "#fff" },
      },
      // title: { display: true, text: "", color: "#fff", },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        ticks: { color: "#ccc" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
      y: {
        ticks: { color: "#ccc" },
        grid: { color: "rgba(255,255,255,0.1)" },
      },
    },
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        backgroundColor: "#0a1d33",
        padding: "1rem",
        borderRadius: "8px",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
};

export default MultiAreaChart;
